<app-preloader></app-preloader>
<app-top-header *ngIf="!(location == '/home-2' || location == '/home-5')"></app-top-header>
<app-navbar></app-navbar>
<ng-particles [id]="id" [options]="particlesOptions" [particlesInit]="particlesInit"></ng-particles>
<router-outlet></router-outlet>
<app-footer></app-footer>

